// extracted by mini-css-extract-plugin
module.exports = {"parallax":"ParallaxHeader_parallax__2gD7y","intro":"ParallaxHeader_intro__2JvZ1","form":"ParallaxHeader_form__2SILw"};